import { ReactNode } from 'react';
import { PermissionType } from './types';

import { useAuth } from '@hooks/useAuth';

const tokenAuthNeeded = (authPermission: string[]): boolean =>
  authPermission.includes('token');

const AllowedComponent = (
  element?: ReactNode,
  redirection?: ReactNode,
  permissions?: PermissionType,
  isToken?: string,
): ReactNode => {
  const { isLogin } = useAuth();

  if (permissions && tokenAuthNeeded(permissions.auth)) {
    if (isLogin || isToken) {
      return element;
    } else {
      return redirection;
    }
  } else {
    return element;
  }

  //   return element;
};

export { AllowedComponent };
